import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useGetAvailableLanguages, getLanguagesInputValue } from "../../hooks/global/Languages";
import { validate } from '../../helpers/general';
import SweetAlert from "sweetalert-react";

function GroupTextInput({ index, value = "", isText = false, onSave = null, open = false, disabled = false, required = true, SAlert = false, rule = null, maxLength=-1 }) {
    const { t, i18n } = useTranslation();
    const availableLan = useGetAvailableLanguages();
    const [isOpen, setIsOpen] = useState(open);
    const [inputValue, setInputValue] = useState(() => getLanguagesInputValue(value, availableLan));
    const [validateData, setValidateData] = useState();
    const [length, setLength] = useState();

    const validateRules = availableLan.map((lng) => { return { index: lng, regex:  (rule) ? rule :/^.+$/s, condition: required } });

    useEffect(() => {
        if(value || value === "") {
            setInputValue(getLanguagesInputValue(value, availableLan));
            countLength(value)
        }
    },   [value]);

    const countLength = (value) => {
        let temp = {...length};
        availableLan.forEach((e) => {
            temp[e] = value[e]?.length || 0;
        })
        setLength(temp);
    }

    const handleInputChange = (event) => {

        let temp = { ...inputValue }
        if(maxLength < 0 || event.target.value.length <= maxLength)
        temp[event.target.name] = event.target.value
        setInputValue(temp);
        countLength(temp);

    };

    const onClick = () => {
        setIsOpen(disabled ? isOpen : !isOpen);
    };

    const onCancel = () => {
        setInputValue(value)
        setValidateData(null);
        setIsOpen(!isOpen);
    };

    const onConfirm = () => {

        const validatorErrors = validate(inputValue, validateRules);

        setValidateData(validatorErrors);

        if (!validatorErrors.e) {
            if(!SAlert) setIsOpen(!isOpen);
            if (!disabled) {
                onSave?.({
                    type: 'onSave',
                    data: inputValue,
                    index: index,
                });
            }
        }
    }
    return (
        <div className={`editEntity ${index}`} >
            {(!isOpen) ? (
                <>
                    <div className={disabled ? "groupOverview-listCustom" : "editEntityInner editEntityInnerUpdate"} onClick={onClick}>
                        {availableLan.map((lng, key) => {
                            return (
                                <div key={lng}>
                                    <p key={lng}>
                                        <span>{lng}:</span> {inputValue?.[lng]}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </>
            ) : (
                <div className="editEntityForm">
                    <div>
                        <div className="editEntityFormInputWrap">
                            <div className="langSelectInputWrap">
                                {availableLan.map((lng, key) => {
                                    return (
                                        <div key={key}>
                                            <label>{lng}: </label>
                                            {(!isText) ? (
                                                <input
                                                    type="text"
                                                    key={lng}
                                                    value={inputValue?.[lng] || ""}
                                                    name={lng}
                                                    onChange={handleInputChange}
                                                    placeholder=""
                                                    autoFocus={true}
                                                />
                                            ) : (
                                                <textarea
                                                    key={lng}
                                                    autoFocus={true}
                                                    rows="4"
                                                    cols="50"
                                                    name={lng}
                                                    value={inputValue?.[lng] || ""}
                                                    onChange={handleInputChange}
                                                />
                                            )}
                                             {maxLength > 0 && <div className="position-absolute top-0 start-100  translate-middle badge rounded-pill bg-secondary">{155-length?.[lng]}</div>}

                                            {(validateData?.e && !SAlert && !validateData.newValidateData[lng]) && <span className="validation">{t("err.req")}</span>}

                                        
                                        </div>
                                    )
                                })}

                            </div>
                            <button className="btn btn-default btn-confirm" onClick={() => { onConfirm() }}>Potrdi</button>
                            <button type="button" className="btn btn-default btn-cancel" onClick={() => { onCancel() }}>Prekliči</button>

                            {(validateData && SAlert) && (
                                <SweetAlert
                                    show={validateData.e}
                                    title={t("err.mo")}
                                    type="warning"
                                    text={t("err.add")}
                                    confirmButtonText="Ok"
                                    onConfirm={() => setValidateData({ e: false })}
                                />
                            )}

                        </div>
                    </div>
                </div>
            )}
        </div >
    );
}

export default GroupTextInput;
